var automaticFields = [];
var manualFields = [];

function trim (myString)
{
return myString.replace(/^\s+/g,'').replace(/\s+$/g,'')
}

function cerrar_popup() {
	$('.dest_el li').removeClass("pop_active");
	$('#popups').html("");
}

function generar_input_featured(lang_id) {
	var valor=$('select#featureds_ok-'+lang_id+' option').length;
	//alert(valor);
	var str = "";
	for(var cont=0;cont<valor;cont++) {
		str+=$('select#featureds_ok-'+lang_id+' option:eq('+cont+')').val();
		if(cont+1<valor)
			str+=",";
	}
	$('#featured-'+lang_id).val(str);
	
	
}
function generar_input_filterfaq(lang_id) {
	var valor=$('select#featureds_ok-'+lang_id+' option').length;
	//alert(valor);
	var str = "";
	for(var cont=0;cont<valor;cont++) {
		str+=$('select#featureds_ok-'+lang_id+' option:eq('+cont+')').val();
		if(cont+1<valor)
			str+=",";
	}
	$('#filterfaq-'+lang_id).val(str);
	
	
}

function comprobar_repetir(item,repeat){
	for(var cont=0; cont<$('.ui-tabs-panel').length; cont++)
	{
		contimg = $(item+":eq("+cont+") li").length;
		if(contimg>0)
			$(repeat+":eq("+cont+")").show();
		else
			$(repeat+":eq("+cont+")").hide();
	}
	
}

function poner_botones(item) {
	str = $(item).html();
	str = $(str);
	numero_filas = $(str).find("tr:first td").length;
	width_fila = $(item).width()/numero_filas;
	str_fin = '<tr><td class="action"></td>';
	for(var cont=0;cont<numero_filas;cont++) {
		str_fin += '<td class="actionup" style="width: '+width_fila+'px;">X</td>';
	}
	str_fin += '</tr>';
	$(item).find("thead").prepend(str_fin);
	
	
	$(item).find("tbody tr").each(function(cont,tr){
		$(tr).prepend('<td class="action" style="width:10px;">X</td>');
	})
	//$(str).prepend();
}

function traducir(item,itemresult,edit) {
	str = $(item).html();
	str = $(str);
	//if(edit==undefined) {
		$(str).find('.action').remove();
		$(str).find('.actionup').parent("tr").remove();
		/*$(str).find("tr:first").remove();
		$(str).find("tr").each(function(cont, tr) {
			$(tr).find("td:first").remove();
		})*/
	//}
	tedes = $(str).find("td").length;
	if(tedes > 1)
		$(itemresult).val($(str).html($(str).clone()).html());
	else
		$(itemresult).val("");
}
function inManualFields(fieldName)
{
	for (var i = manualFields.length - 1; i >= 0; i--) {
		if(manualFields[i] === fieldName)
			return true;
	};
	return false;
}

function addManualField(fieldName)
{
	if(!inManualFields(fieldName))
		manualFields.push(fieldName);
}

function setManualFieldsListeners()
{
	$(document).on('click', '.manual-field:not(.ckeditor):not([data-target-field^="link-"])', function(){
		var ok = confirm('¿Quiere copiar este contenido a los demás idiomas? Se borrará el contenido previamente introducido.');
		if(ok)
		{
			var target = $('#'+$(this).attr('data-target'));
			var field = $('[data-field="'+$(this).attr('data-target-field')+'"]');
			$(field).val($(target).val());
		}
		return false;
	}).on('click', '.manual-field[data-target-field^="link-"]', function(){
		var ok = confirm('¿Quiere copiar este enlace a los demás idiomas? Se borrará el enlace que hubiese en esta posición.');
		if(ok)
		{
			var target = $(this).attr('data-target');
			var url = $('input[id=url-'+target+']').val();
			var text = $('input[id=text-'+target+']').val();
			var ddslickData = $('[id=icon-'+target+']').data('ddslick');
			var iconIndex = ddslickData.selectedIndex;

			var fieldLangIndep = $(this).attr('data-target-field');
			$('[id^="icon-'+fieldLangIndep+'"]').ddslick('select', {index: iconIndex});
			$('[id^="url-'+fieldLangIndep+'"]').val(url);
			$('[id^="text-'+fieldLangIndep+'"]').val(text);
		}
		return false;
	}).on('click', '.manual-field.ckeditor', function(){
		var ok = confirm('¿Quiere copiar este contenido a los demás idiomas? Se borrará el contenido previamente introducido.');
		if(ok)
		{
			var target = $('#'+$(this).attr('data-target'));
			var field = $('[data-field="'+$(this).attr('data-target-field')+'"]');
			var text = CKEDITOR.instances[$(target).attr('id')].getData();
			for (var i = 0; i < field.length; i++) {
				CKEDITOR.instances[$(field[i]).attr('id')].setData(text);
			};

			$(field).val($(target).val());
		}
		return false;
	});
}

function borrarCKEDITORS() {
	for(cont=0;cont<$('.ck').length;cont++)
	{
		name=$('.ck:eq('+cont+')').attr("id");
		if(CKEDITOR.instances[name])
			   delete CKEDITOR.instances[name];
	}
}

function inAutomaticFields(fieldName)
{
	for (var i = automaticFields.length - 1; i >= 0; i--) {
		if(automaticFields[i] === fieldName)
			return true;
	};
	return false;
}

function addAutomaticField(fieldName)
{
	if(!inAutomaticFields(fieldName))
		automaticFields.push(fieldName);
}

function setAutomaticFieldsListeners()
{
	for (var i = 0; i < automaticFields.length; i++) {
		$(document).on('change', 'input[type="text"][data-field="'+automaticFields[i]+'"]', function(){
			var fieldName = $(this).attr('data-field');
			$('input[type="text"][data-field="'+fieldName+'"]').not($(this)).val($(this).val());
		});
		$(document).on('change', 'input[type="checkbox"][data-field="'+automaticFields[i]+'"]', function(){
			var fieldName = $(this).attr('data-field');
			if($(this).is(':checked'))
				$('input[type="checkbox"][data-field="'+fieldName+'"]').not($(this)).attr('checked', true);
			else
				$('input[type="checkbox"][data-field="'+fieldName+'"]').not($(this)).attr('checked', false);

			$('input[type="checkbox"][data-field="'+fieldName+'"]').button({icons:{primary:'ui-icon-check'}}).button("refresh");
		});
		$(document).on('keyup', 'textarea:not(.ck)[data-field="'+automaticFields[i]+'"]', function(){
			var fieldName = $(this).attr('data-field');
			$('textarea:not(.ck)[data-field="'+fieldName+'"]').not($(this)).val($(this).val());
		});
		$(document).on('change', 'select[data-field="'+automaticFields[i]+'"]', function(){
			var fieldName = $(this).attr('data-field');
			$('select[data-field="'+fieldName+'"] option[value='+$(this).val()+']').attr('selected', 'selected');
			//$('.selectType').selectmenu();

		});
	};
}

function autoslug() {
	var slug_fields = $('[data-field=slug]');
	var field_tag = null;
	var possible_fields = ["titleweb", "title", "titulo", "nombre"];
	for (var i = 0; i < possible_fields.length; i++) {
		if ($('[data-field='+possible_fields[i]+']').length>0) {
			field_tag = possible_fields[i];
			break;
		}
	};
	if (field_tag == null) { return false; };
	for (var i = slug_fields.length - 1; i >= 0; i--) {
		var slug_field = slug_fields[i];
		var lang = $(slug_field).attr('name').replace('slug-', '');
		var field = $('[name='+field_tag+'-'+lang+']');
		$(field).attr('data-prev-text', $(field).val());

		$(document).on('keyup', field, function() {
			var prev_text = $(field).attr('data-prev-text');
			var slug_from_prev_text  = slugify(prev_text);
			var slug_from_slug_field = slugify($(slug_field).val());
			if (slug_from_slug_field == slug_from_prev_text) {
				$(slug_field).val(slugify($(field).val()));
			};
			$(field).attr('data-prev-text', $(field).val());
		});
	};
}

$(document).on('ready', function(){
	setAutomaticFieldsListeners();
	setManualFieldsListeners();
	autoslug();
	$('form').on('submit', function(){ // preprocess links
		var form = $(this);
		$('[data-target-field^=link-]').each(function(i, button){
			var target = $(button).attr('data-target');
			var field = $('#text-'+target);
			$(form).prepend('<input type="hidden" value="'+field.val()+'" name="'+field.attr('id')+'">');
			var field = $('#url-'+target);
			$(form).prepend('<input type="hidden" value="'+field.val()+'" name="'+field.attr('id')+'">');
			var field = $('#icon-'+target);
			$(form).prepend('<input type="hidden" value="'+field.data('ddslick').selectedData.value+'" name="'+field.attr('id')+'">');
		});
		return true;
	});
});